module.exports = __webpack_public_path__ + "img/report_3.7d516e0e.png";